import api from './api';

export interface WAUResult {
  semanas: Array<{ semana_inicio: string; yw: number; wau: number }>;
  total_atual: number;
  delta_pct: number;
}

export interface TransparenciaData {
  cashback_cve: number;
  utilizadores: number;
  transacoes: number;
  pontos_distribuidos: number;
  comerciantes_ativos: number;
  mes_referencia?: string;
}

export interface RankingUtilizador {
  user_id: string;
  nome: string;
  email: string;
  num_transacoes: number;
  total_pontos: number;
}

export interface RankingComerciante {
  entity_id: number;
  entidade_nome: string;
  clientes_unicos: number;
  num_transacoes: number;
  volume_cve: number;
  ticket_medio: number;
}

export interface ConversaoData {
  campanhas: {
    total: number;
    enviados: number;
    falhou: number;
    opt_out: number;
    pendente: number;
    taxa_entrega: number;
  } | null;
  missoes: {
    participantes: number;
    completaram: number;
    reclamaram: number;
    taxa_conclusao: number;
    taxa_reclamacao: number;
  } | null;
  referral: {
    total: number;
    aceites: number;
    taxa_aceitacao: number;
  } | null;
}

class MarketingMetricasService {
  async wau(semanas = 12): Promise<WAUResult> {
    const res = await api.get(`/admin/marketing/metricas/wau?semanas=${semanas}`);
    return res.data.data;
  }
  async transparencia(): Promise<TransparenciaData> {
    const res = await api.get('/admin/marketing/metricas/transparencia');
    return res.data.data;
  }
  async rankingUtilizadores(limit = 10): Promise<RankingUtilizador[]> {
    const res = await api.get(`/admin/marketing/metricas/ranking/utilizadores?limit=${limit}`);
    return res.data.data || [];
  }
  async rankingComerciantes(limit = 10): Promise<RankingComerciante[]> {
    const res = await api.get(`/admin/marketing/metricas/ranking/comerciantes?limit=${limit}`);
    return res.data.data || [];
  }
  async conversao(): Promise<ConversaoData> {
    const res = await api.get('/admin/marketing/metricas/conversao');
    return res.data.data;
  }
  async atribuicao(): Promise<{ fontes: any[]; campanhas: any[]; total: number }> {
    const res = await api.get('/admin/marketing/metricas/atribuicao');
    return res.data.data;
  }
  async resumoDiario(): Promise<{ resumo: string; gerado_em: string; periodo: string; meta: any }> {
    const res = await api.get('/admin/marketing/resumo-diario');
    return res.data.data;
  }
  async funil(): Promise<{
    semana_atual: {
      registos: number;
      kyc_aprovado: number;
      kyc_pendente: number;
      primeira_transacao: number;
      taxa_kyc_pct: number | null;
      taxa_activacao_pct: number | null;
    };
    historico_firestore: any[];
  }> {
    const res = await api.get('/admin/marketing/metricas/funil');
    return res.data.data;
  }
}

export default new MarketingMetricasService();
